var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.994 22.1884L37.0442 35.1818C38.1486 38.2503 38.6063 43.3895 33.8497 49.713C33.5171 50.1577 33.0923 50.5252 32.6046 50.7907C32.1168 51.0561 31.5774 51.2131 31.0234 51.2509C30.9314 51.2509 30.8418 51.2509 30.7497 51.2509C30.2406 51.251 29.7363 51.1507 29.2659 50.9558C28.7955 50.7609 28.3681 50.4752 28.0082 50.115L16.3202 38.415L5.99576 48.7467C5.63221 49.1102 5.13912 49.3145 4.62498 49.3145C4.11084 49.3145 3.61775 49.1102 3.2542 48.7467C2.89064 48.3831 2.6864 47.89 2.6864 47.3759C2.6864 46.8618 2.89064 46.3687 3.2542 46.0051L13.5859 35.6807L1.88826 23.983C1.50376 23.598 1.20465 23.1364 1.01039 22.6282C0.81613 22.1199 0.731082 21.5764 0.760783 21.0332C0.790483 20.4899 0.934265 19.9589 1.18277 19.4749C1.43127 18.9908 1.77893 18.5646 2.2031 18.2238C8.35951 13.2565 14.2519 14.2325 16.8312 15.0414L29.8125 2.01418C30.1723 1.65426 30.5995 1.36875 31.0697 1.17396C31.5399 0.979165 32.0439 0.878906 32.5528 0.878906C33.0618 0.878906 33.5657 0.979165 34.0359 1.17396C34.5061 1.36875 34.9333 1.65426 35.2932 2.01418L49.9915 16.7101C50.718 17.4364 51.1264 18.4215 51.1268 19.4488C51.1273 20.476 50.7198 21.4614 49.994 22.1884Z",
    fill: "#E9E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector (2).48f8c35f39aba2c61f0acbea4c9ef3d6.svg";
export { ForwardRef as ReactComponent };